import {
  MODAL_HIDDEN,
  MODAL_DATA_LOADED,
  CSV_UPLOADED,
  LOADING,
  FAILED,
} from '../actions/constants';
import Column from '../util/Column';

const INITIAL_STATE = {
  errorMsg: null, // error message, if there was a problem with the upload
  csvUploadId: null, // id associated with the CSV that was uploaded
  columns: null, // list of Column objs
  loading: false,
  readyForSave: false,
};

function interaction(state, payload) {
  if (payload.json) {
    if (payload.json._errorMsg) {
      return { ...INITIAL_STATE, errorMsg: payload.json._errorMsg };
    }
    return {
      ...INITIAL_STATE,
      csvUploadId: payload.json._id,
      columns: payload.json._columns.map((c) => Column.build(c)),
    };
  }
  if (payload.error) {
    return { ...INITIAL_STATE, errorMsg: payload.error };
  }
}

function readyForSave(newState) {
  return !newState.errorMsg && newState.csvUploadId;
}

const modalCSVUpload = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED: {
      return state;
    }
    case FAILED: {
      if (action.awaiting === CSV_UPLOADED) {
        return { ...INITIAL_STATE, errorMsg: 'Problem uploading CSV' };
      }
      return state;
    }
    case LOADING: {
      if (action.awaiting === CSV_UPLOADED) {
        return { ...INITIAL_STATE, loading: true };
      }
      return state;
    }
    case CSV_UPLOADED: {
      const newState = interaction(state, action.payload);
      return { ...newState, readyForSave: readyForSave(newState) };
    }
    default:
      return state;
  }
};

export default modalCSVUpload;
